import { createActionCreator } from 'deox';
import { Article, Paging } from '@/types';
import { ArticleForm } from '@/services/service-directory/article';

export const fetchArticlesActions = {
  request: createActionCreator(
    'FETCH_ARTICLES_REQUEST',
    (resolve) => (
      isGlobal: boolean,
      pageNumber: number,
      pageSize: number,
      keyword?: string,
      organisationId?: string,
      tag?: string,
      recaptchaToken?: string
    ) => resolve({ isGlobal, pageSize, pageNumber, keyword, organisationId, tag, recaptchaToken })
  ),
  success: createActionCreator('FETCH_ARTICLES_SUCCESS', (resolve) => (data: Article[], paging: Paging) =>
    resolve({ data, paging })
  ),
  failure: createActionCreator('FETCH_ARTICLES_FAILURE', (resolve) => (error: any) => resolve({ error })),
  reset: createActionCreator('FETCH_ARTICLES_RESET'),
};

export const fetchArticlesDashboardActions = {
  request: createActionCreator(
    'FETCH_ARTICLES_DASHBOARD_REQUEST',
    (resolve) => (isGlobal: boolean, pageNumber: number, pageSize: number, keyword?: string, organisationId?: string) =>
      resolve({ isGlobal, pageSize, pageNumber, keyword, organisationId })
  ),
  success: createActionCreator('FETCH_ARTICLES_DASHBOARD_SUCCESS', (resolve) => (data: Article[], paging: Paging) =>
    resolve({ data, paging })
  ),
  failure: createActionCreator('FETCH_ARTICLES_DASHBOARD_FAILURE', (resolve) => (error: any) => resolve({ error })),
};

export const fetchArticleBySlugActions = {
  request: createActionCreator('FETCH_ARTICLE_BY_SLUG_REQUEST', (resolve) => (slug: string) => resolve({ slug })),
  success: createActionCreator('FETCH_ARTICLE_BY_SLUG_SUCCESS', (resolve) => (article: Article) =>
    resolve({ article })
  ),
  failure: createActionCreator('FETCH_ARTICLE_BY_SLUG_FAILURE', (resolve) => (error: any) => resolve({ error })),
};

export const fetchArticleViewOnlyActions = {
  request: createActionCreator('FETCH_ARTICLE_VIEW_ONLY_REQUEST', (resolve) => (slug: string, recaptchaToken: string) =>
    resolve({ slug, recaptchaToken })
  ),
  success: createActionCreator('FETCH_ARTICLE_VIEW_ONLY_SUCCESS', (resolve) => (article: Article) =>
    resolve({ article })
  ),
  failure: createActionCreator('FETCH_ARTICLE_VIEW_ONLY_FAILURE', (resolve) => (error: any) => resolve({ error })),
};

export const fetchArticleDashboardActions = {
  request: createActionCreator('FETCH_ARTICLE_DASHBOARD_REQUEST', (resolve) => (slug: string) => resolve({ slug })),
  success: createActionCreator('FETCH_ARTICLE_DASHBOARD_SUCCESS', (resolve) => (article: Article) =>
    resolve({ article })
  ),
  failure: createActionCreator('FETCH_ARTICLE_DASHBOARD_FAILURE', (resolve) => (error: any) => resolve({ error })),
};

export const loadMoreArticlesActions = {
  request: createActionCreator(
    'LOAD_MORE_ARTICLES_REQUEST',
    (resolve) => (isGlobal: boolean, pageNumber: number, pageSize: number, keyword?: string) =>
      resolve({ isGlobal, pageSize, pageNumber, keyword })
  ),
  success: createActionCreator(
    'LOAD_MORE_ARTICLES_SUCCESS',
    (resolve) => ({ data, paging }: { data: Article[]; paging: Paging }) => resolve({ data, paging })
  ),
  failure: createActionCreator('LOAD_MORE_ARTICLES_FAILURE', (resolve) => (error: any) => resolve({ error })),
};

export const createArticleActions = {
  request: createActionCreator('CREATE_ARTICLE_REQUEST', (resolve) => (article: ArticleForm, isGlobal: boolean) =>
    resolve({ article, isGlobal })
  ),
  success: createActionCreator('CREATE_ARTICLE_SUCCESS'),
  failure: createActionCreator('CREATE_ARTICLE_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const editArticleActions = {
  request: createActionCreator(
    'EDIT_ARTICLE_REQUEST',
    (resolve) => (id: string, article: ArticleForm, isGlobal: boolean) => resolve({ id, article, isGlobal })
  ),
  success: createActionCreator('EDIT_ARTICLE_SUCCESS'),
  failure: createActionCreator('EDIT_ARTICLE_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const deleteArticleActions = {
  request: createActionCreator('DELETE_ARTICLE_REQUEST', (resolve) => (id: string, isGlobal: boolean) =>
    resolve({ id, isGlobal })
  ),
  success: createActionCreator('DELETE_ARTICLE_SUCCESS'),
  failure: createActionCreator('DELETE_ARTICLE_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};
